<script setup lang="ts">
import {StatusEnum, StatusEnum_heavyColor, StatusEnum_name} from 'common';
import {ref, toRef, watch} from 'vue';
import {ElBadge} from 'element-plus';

const emit = defineEmits(
    ['update:statusSet'],
);

const props        = defineProps({
    multi    : Boolean,
    statusSet: {
        type    : Array<StatusEnum>,
        required: true,
    },
    occupation: {
        type: Map<StatusEnum, number>,
    },
});
const refStatusSet = toRef(props, 'statusSet');
watch(refStatusSet, () => {
    statusSet.value = refStatusSet.value;
});

const statusSet = ref<StatusEnum[]>([...props.statusSet]);

function tileClass(e: StatusEnum) {
    const on    = statusSet.value.includes(e);
    const color = StatusEnum_heavyColor(e);

    const onoff = on ? `bg-${color}` : `bg-gray-100`;
    return `w-24 py-1 cursor-pointer ${onoff} text-center text-black hover:font-extrabold border-4 border-${color} rounded-lg`;
}

function mainClass() {
    return `flex flex-${(props.multi ? 'row' : 'col')} text-xs py-2 gap-0.5 bg-200`;
}

function onClick(e: StatusEnum) {
    if (statusSet.value.includes(e)) {
        if (props.multi) {
            statusSet.value.splice(statusSet.value.indexOf(e), 1);
        }
    } else {
        if (!props.multi) {
            statusSet.value = [];
        }
        statusSet.value.push(e);
    }
    emit('update:statusSet', [...statusSet.value]);
}

function occupationOf(s: StatusEnum): number | string | undefined {
    return props.occupation?.get(s) ;
}

function isHidden(s: StatusEnum): boolean {
    return !props.occupation?.get(s);
}
</script>

<template>

    <div :class="mainClass()" class="">

        <el-badge :value="occupationOf(StatusEnum.overdue)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.overdue)">
            <div :class="tileClass(StatusEnum.overdue)"
                 @click="onClick(StatusEnum.overdue)">
                {{ StatusEnum_name(StatusEnum.overdue) }}
            </div>
        </el-badge>

        <el-badge :value="occupationOf(StatusEnum.open)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.open)">
            <div :class="tileClass(StatusEnum.open)"
                 @click="onClick(StatusEnum.open)">
                {{ StatusEnum_name(StatusEnum.open) }}
            </div>
        </el-badge>

        <el-badge :value="occupationOf(StatusEnum.future)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.future)">
            <div :class="tileClass(StatusEnum.future)"
                 @click="onClick(StatusEnum.future)">
                {{ StatusEnum_name(StatusEnum.future) }}
            </div>
        </el-badge>

        <el-badge :value="occupationOf(StatusEnum.submitted)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.submitted)">
            <div :class="tileClass(StatusEnum.submitted)"
                 @click="onClick(StatusEnum.submitted)">
                {{ StatusEnum_name(StatusEnum.submitted) }}
            </div>
        </el-badge>

        <el-badge :value="occupationOf(StatusEnum.accepted)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.accepted)">
            <div :class="tileClass(StatusEnum.accepted)"
                 @click="onClick(StatusEnum.accepted)">
                {{ StatusEnum_name(StatusEnum.accepted) }}
            </div>
        </el-badge>

        <el-badge :value="occupationOf(StatusEnum.rejected)" color="green" class="item" :offset="[-20,0]"
                  :hidden="isHidden(StatusEnum.rejected)">
            <div :class="tileClass(StatusEnum.rejected)"
                 @click="onClick(StatusEnum.rejected)">
                {{ StatusEnum_name(StatusEnum.rejected) }}
            </div>
        </el-badge>

    </div>

</template>
